import React from "react";

import * as styles from "./ExtraProductInfo.css";

import { ProductBenefits } from "./ProductBenefits/ProductBenefits";

import type { ProductBenefits as ProductBenefitsType } from "@shared/graphql.types";
import { ProductInfoSection } from "./ProductInfoSection/ProductInfoSection";

type Props = {
  productBenefits?: ProductBenefitsType;
  ingredientList?: string;
  candleSafety?: string;
};

export const ExtraProductInfo: React.FC<Props> = ({
  productBenefits,
  ingredientList,
  candleSafety
}) => {
  if (!productBenefits && !ingredientList && !candleSafety) return null;
  return (
    <section className={styles.container}>
      {productBenefits && (
        <ProductBenefits
          title="Product Benefits"
          extraDescriptionTitle="Description"
          extraDescription={productBenefits.extraDescription ?? undefined}
          items={productBenefits.items ?? []}
          cList={productBenefits.cList ?? undefined}
        />
      )}

      <ProductInfoSection
        title="Ingredient List"
        textContent={ingredientList}
      />
      <ProductInfoSection
        title="Candle Safety"
        textContent={candleSafety}
        buttonText="Read More"
      />
    </section>
  );
};
